var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.3333 3.00016C27.3333 1.5335 26.1333 0.333496 24.6667 0.333496H3.33334C1.86667 0.333496 0.666672 1.5335 0.666672 3.00016V19.0002C0.666672 20.4668 1.86667 21.6668 3.33334 21.6668H24.6667C26.1333 21.6668 27.3333 20.4668 27.3333 19.0002V3.00016ZM24.6667 3.00016L14 9.66683L3.33334 3.00016H24.6667ZM24.6667 19.0002H3.33334V5.66683L14 12.3335L24.6667 5.66683V19.0002Z","fill":"white"}));
}

Email.defaultProps = {"width":"28","height":"22","viewBox":"0 0 28 22","fill":"none"};

module.exports = Email;

Email.default = Email;
